import { CivilMatterCaseInformationNewMexico } from './CivilMatterCaseInformationNewMexico';

export default CivilMatterCaseInformationNewMexico;
